import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import HttpRunner from '../query';
import DetectLanguageQuery from '../detectLanguageQuery';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocV2DetectLanguages extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_DETECT_LANGUAGES)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Detect Languages</h3>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V2_DETECT_LANGUAGES}
                </code>
                <div className="description">
                    The detect-languages endpoint detects and locates all languages found in a piece of 
                    text. Multiple languages may be detected in the text and returned as an array of 
                    text segments where the same language was detected. Each segment includes the start and 
                    end location of that language segment in the original text.<br/>
                 </div>

                <h4 className="heading-2" id="detectlanguagesv2_request">Request</h4>
                <div className="description">
                    The detect-languages request is a JSON object that contains the request parameters.<br/>
                </div>

                <h4 className="heading-3" id="detectlanguagesv2_request_object">Request object</h4>

                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">requestId</td>
                        <td className="meaning">The system generated request ID.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">documentId</td>
                        <td className="meaning">A client supplied tracking identifier.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">text</td>
                        <td className="meaning">The UTF-8 block of text to be analyzed for languages.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required    
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">languageCandidates</td>
                        <td className="meaning">List of ISO-639-1 and/or ISO-639-3 codes for languages to be retuned; ; "*" will use all models.
                        </td>
                        <td className="type">String[]</td>
                        <td className="constraints">Optional    
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2" id="detectlanguagesv2_response">Response</h4>
                <div className="description">
                    The detect-languages response object contains an array of text segments where the 
                    same language was detected. Each segment includes the start and end location of that 
                    language segment in the original text.
                </div>

                <h4 className="heading-3" id="detectlanguagesv2_response_object">Response object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">segments</td>
                        <td className="meaning">Array of language segments detected in the text with the start and end locations within the text block.
                        </td>
                        <td className="type">An array of <a href="#detectlanguagesv2_segment_object">language segments</a>.</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-4" id="detectlanguagesv2_segment_object">Language segment</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">language</td>
                        <td className="meaning">Name of the language.
                        </td>
                        <td className="type">String</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">iso639_1</td>
                        <td className="meaning">Two character language code.
                        </td>
                        <td className="type">String</td>
                        <td className="type">See {miscUtils.createExternalLink('https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes','ISO 639-1/3 codes')} for codes.</td>
                    </tr>
                    <tr>
                        <td className="attribute">iso639_3</td>
                        <td className="meaning">Three character language code.
                        </td>
                        <td className="type">String</td>
                        <td className="type">See {miscUtils.createExternalLink('https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes','ISO 639-1/3 codes')} for codes.</td>
                    </tr>
                    <tr>
                        <td className="attribute">text</td>
                        <td className="meaning">The text within the original document.
                        </td>
                        <td className="type">String</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">position</td>
                        <td className="meaning">Object that contains the start position and length within the original document of the detected language text.
                        </td>
                        <td className="type">JSON Object</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Example</h4>
                <div className="example-content host">
                    <pre>
                        POST {urlHandler.API_ENDPOINT_V2_DETECT_LANGUAGES}<br/>
                        Accept: application/json<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        Content-Type: application/json<br/>
                        <br/>
                    </pre>
                    <pre>{JSON.stringify(examples.EXAMPLE_REQUEST_DETECT_LANGUAGES, null, 3)}</pre>
                </div>
                <HttpRunner example="detectlanguages1" 
                    query="detect-languages2" 
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_DETECT_LANGUAGES) : null}
                />
            </div>
        );
    }
}

export default DocV2DetectLanguages;